module.exports = __webpack_public_path__ + "img/minimize.bf07d799.svg";